// @ts-ignore
export let plugin3d: any; 

export function changePlugin3d(val: any) {
  plugin3d = val;
}